"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdornmentLeft = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AdornmentMixin = require("../../mixins/components/AdornmentMixin");
var _Adornment = require("../Adornment/Adornment.styles");
var AdornmentLeft = /*#__PURE__*/(0, _styledComponents.default)(_Adornment.StyledAdornment).withConfig({
  displayName: "AdornmentLeft",
  componentId: "c11n-8-107-0__sc-i8uzd9-0"
})(["", ""], _AdornmentMixin.AdornmentLeftMixin);
exports.AdornmentLeft = AdornmentLeft;
AdornmentLeft.displayName = 'AdornmentLeft';

/** @component */